import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TreeInputOptions from "./input/TreeInputOptions";
import ChannelParameterInputOptions from "./input/ChannelParametersInputOptions";
import ManningCoefficientInputOtions from "./input/ManningCoefficientInputOptions";
import CatchmentInputOptions from "./input/CatchmentInputOptions";
import IdealVegetationInputOptions from "./input/IdealVegetationInputOptions";
import NumberBox from "../elements/NumberBox";
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import CriticalShearStressOptions from './input/CriticalShearStressOptions';
import WoodTransportOptions from "./input/WoodTransportOptions";
import VIEW_MODE from '../common.js';
import BankDiagram from '../elements/BankDiagram/BankDiagram';

export default function InputPanel(props) {
  const updateParameters = props.updateParameters;
  const parameters = props.parameters;
  const view_mode = props.view_mode;

  const [showVegeHelpModal, setShowVegeHelpModal] = React.useState(false);

  function handleTextBoxOnChange(event) {
    console.log(event.target);
    if (
      event.target.name === "InnerTreeSpecies" ||
      event.target.name === "OuterTreeSpecies" ||
      event.target.name === "criticalShearStressModel" ||
      event.target.name === "calculationName" ||
      event.target.name === "manningCoefficientModel"
    ) {
      updateParameters({
        ...parameters,
        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "idealVegetationUseTimeInterval") {
      updateParameters({
        ...parameters,
        [event.target.name]: event.target.checked,
        idealVegetationUseTreeSize: !event.target.checked,
      });
    } else if (event.target.name === "idealVegetationUseTreeSize") {
      updateParameters({
        ...parameters,
        [event.target.name]: event.target.checked,
        idealVegetationUseTimeInterval: !event.target.checked,
      });
    } else if (event.target.name === "criticalShearStressUserDefinedPaOuterCustom" || event.target.name === "criticalShearStressUserDefinedPaOuter") {

      const val = event.target.value === ""
        ? event.target.value
        : parseFloat(event.target.value)

      updateParameters({
        ...parameters,
        "criticalShearStressUserDefinedPaOuter": val,
        "tauCOuterSD": (val / 2).toPrecision(2),
      });
    } else if (event.target.name === "criticalShearStressUserDefinedPaInnerCustom" || event.target.name === "criticalShearStressUserDefinedPaInner") {

      const val = event.target.value === ""
        ? event.target.value
        : parseFloat(event.target.value)


      updateParameters({
        ...parameters,
        "criticalShearStressUserDefinedPaInner": val,
        "tauCInnerSD": (val / 2).toPrecision(2),
      });
    } else {
      updateParameters({
        ...parameters,
        [event.target.name]:
          event.target.value === ""
            ? event.target.value
            : parseFloat(event.target.value)
      });
    }
  }

  function onFormSubmit(event) {
    if (
      parameters.channelWidth / 2 > parameters.InnerBankTreeDistance
    ) {
      props.setError("Check Inner Tree Distance Parameter");
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (
      parameters.channelWidth / 2 > parameters.OuterBankTreeDistance
    ) {
      props.setError("Check Outer Tree Distance Parameter");
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    props.submit();
  }

  return (
    <Form onSubmit={onFormSubmit}>
      <Container>
        <Row>
          <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
            <ChannelParameterInputOptions
              parameters={parameters}
              handleTextBoxOnChange={handleTextBoxOnChange}
              view_mode={view_mode}
            />

          </Col>

          <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
            <CatchmentInputOptions
              parameters={parameters}
              handleTextBoxOnChange={handleTextBoxOnChange}
              updateParameters={updateParameters}
              view_mode={view_mode}
            />
            <div style={{ marginTop: "1em" }}>
              <ManningCoefficientInputOtions
                parameters={parameters}
                view_mode={view_mode}
                handleTextBoxOnChange={handleTextBoxOnChange}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col style={{ marginBottom: "1em" }}>
            <CriticalShearStressOptions
              parameters={parameters}
              handleTextBoxOnChange={handleTextBoxOnChange}
              view_mode={view_mode}
            />
          </Col>
        </Row>

        <Row>
          <Col style={{ marginBottom: "1em" }}>
            <WoodTransportOptions
              parameters={parameters}
              handleTextBoxOnChange={handleTextBoxOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col style={{ marginBottom: "1em" }}>
            <Card>
              <Card.Header>Vegetation{" "}
                <Button tabIndex="-1" variant="light" className="d-inline-flex align-items-center" onClick={() => setShowVegeHelpModal(true)}>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </Button>
              </Card.Header>
              <Card.Body>
                <Modal centered show={showVegeHelpModal} size="lg" onHide={() => setShowVegeHelpModal(false)}>
                  <Modal.Header closeButton>
                    Vegetation Help
                  </Modal.Header>
                  <Modal.Body>
                    <div>
                      <h2>Channel Parameter Diagram</h2>
                      <img width="100%" src="/images/stream_xsection_vegetation.png" />
                      <hr />
                    </div>
                  </Modal.Body>

                </Modal>

                <Row>
                  <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
                    <TreeInputOptions
                      name="Inner Bank Tree"
                      parameters={parameters}
                      handleTextBoxOnChange={handleTextBoxOnChange}
                    />
                  </Col>
                  <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
                    <TreeInputOptions
                      name="Outer Bank Tree"
                      parameters={parameters}
                      handleTextBoxOnChange={handleTextBoxOnChange}
                    />
                  </Col>
                </Row>


                <Row>
                  <Col md={6} sm={12}>
                    <NumberBox
                      label="Inner Bank Height"
                      controlId="bankHeightInner"
                      unit="m"
                      step="0.01"
                      info="Used only for calculating Root Area Ratio. If left blank, Catchment Area will be used to calculate bank height"
                      name="bankHeightInner"
                      value={parameters.bankHeightInner}
                      onChange={handleTextBoxOnChange}
                      required={false}
                    />
                  </Col>
                  <Col md={6} sm={12}>
                    <NumberBox
                      label="Outer Bank Height"
                      controlId="bankHeightOuter"
                      unit="m"
                      step="0.01"
                      info="Used only for calculating Root Area Ratio. If left blank, Catchment Area will be used to calculate bank height"
                      name="bankHeightOuter"
                      value={parameters.bankHeightOuter}
                      onChange={handleTextBoxOnChange}
                      required={false}
                    />
                  </Col>
                </Row>

              </Card.Body>
            </Card>
          </Col>
        </Row>

        {view_mode == VIEW_MODE.ADVANCED && <Row>
          <Col style={{ marginBottom: "1em" }}>
            <Card>
              <Card.Header>Ideal Vegetation</Card.Header>
              <Card.Body>
                <Form.Group>
                  <Row>
                    <Col lg={6} sm={12}>
                      <Form.Check
                        inline
                        type="radio"
                        name="idealVegetationUseTimeInterval"
                        label="Time Interval"
                        id="idealVegetationUseTimeInterval"
                        checked={parameters.idealVegetationUseTimeInterval}
                        onChange={handleTextBoxOnChange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Tree Size"
                        name="idealVegetationUseTreeSize"
                        id="idealVegetationUseTreeSize"
                        checked={parameters.idealVegetationUseTreeSize}
                        onChange={handleTextBoxOnChange}
                      />
                    </Col>
                  </Row>
                </Form.Group>
                {parameters.idealVegetationUseTimeInterval && (
                  <Row>
                    <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
                      <Card>
                        <Card.Header>Time Interval Options</Card.Header>
                        <Card.Body>
                          <NumberBox
                            label="Years"
                            info="The amount of years to calculate the DBH and height for"
                            unit="yrs"
                            name="idealVegetationTimeInterval"
                            value={parameters.idealVegetationTimeInterval}
                            disabled={parameters.idealVegetationUseTreeSize}
                            onChange={handleTextBoxOnChange}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}

                {!parameters.idealVegetationUseTimeInterval && <Row>
                  <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
                    <IdealVegetationInputOptions
                      name="Inner Bank Tree"
                      parameters={parameters}
                      handleTextBoxOnChange={handleTextBoxOnChange}
                    />
                  </Col>
                  <Col lg={6} sm={12} style={{ marginBottom: "1em" }}>
                    <IdealVegetationInputOptions
                      name="Outer Bank Tree"
                      parameters={parameters}
                      handleTextBoxOnChange={handleTextBoxOnChange}
                    />
                  </Col>
                </Row>}

              </Card.Body>
            </Card>
          </Col>
        </Row>}

        <Row>
          <Col sm={12}>
            <Card>
              <Card.Header>Calculation Information</Card.Header>
              <Card.Body>
                <Form.Label>
                  Calculation Name
                </Form.Label>
                <Form.Control
                  value={parameters.calculationName}
                  name="calculationName"
                  onChange={handleTextBoxOnChange}
                  onFocus={(event) => { event.target.select(); }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <Button variant="primary" type="submit" style={{ width: "100%" }}>
              Calculate Erosion
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
}
/*
*    - Catchment area + Return period (catchmentArea, returnPeriod)
*    - Discharge + duration (discharge, duration)
*    - Catchment area + discharge

*/
